import { render, staticRenderFns } from "./EssayPapersList.vue?vue&type=template&id=4ef85abc&scoped=true&"
import script from "./EssayPapersList.vue?vue&type=script&lang=js&"
export * from "./EssayPapersList.vue?vue&type=script&lang=js&"
import style0 from "./EssayPapersList.vue?vue&type=style&index=0&id=4ef85abc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef85abc",
  null
  
)

export default component.exports